import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: {
    logs: [];
    modalOpen: boolean;
} = {
    logs: [],
    modalOpen: false
};

const voiceToSpeechTracking = createSlice({
    name: 'dashboard',
    initialState: initialState,
    reducers: {
        addVoiceToSpeechTracking: (state, action: PayloadAction<string>) => {
            state.logs.push(action.payload);
        },
        clearVoiceToSpeechTracking: () => {
            return initialState;
        },
        openModal: state => {
            state.modalOpen = true;
        },
        closeModal: state => {
            state.modalOpen = false;
        }
    }
});
export const { addVoiceToSpeechTracking, clearVoiceToSpeechTracking, openModal, closeModal } = voiceToSpeechTracking.actions;
export default voiceToSpeechTracking;
